import {
    SCORECARD_DETAILS_SUCCESS,
    SCORECARD_ID,
    SCORECARD_DETAILS_FAILURE,
    FINANCIAL_DATA,
    NON_FINANCIAL_DATA,
    OVERRIDDEN_DATA,
    VALIDATION_FLAG,
    REQUEST_BODY,
    SCORECARD_FAILURE,
    SCORECARD_SUCCESS,
    EDIT_SCORECARD_SUCCESS,
    EDIT_SCORECARD_FAILURE,
    CORPORATE_MODAL,
    SEARCH_CORPORATE_RESULTS_SCORECARD_SUCCESS,
    SEARCH_CORPORATE_RESULTS_SCORECARD_FAILURE
} from './action';
import { SEARCH_RESULTS_FAILURE } from '../../../components/ReusableComponents/AutoSuggest/action'
const initialState = {
    id: null,
    scoreDetails: null,
    detailsError: null,
    financialSearch: [],
    nonFinancialSearch: [],
    overriddenSearch: [],
    validationFlag: null,
    requestBody: null,
    searchFailure: null,
    editScorecardSuccess: null,
    editScorecardError:null,
    createScorecardSuccess: null,
    createScorecardError: null,
    corporateModal: false,
    corporateResult:[]
};
const createScorecardReducer = (state = initialState, action) => {
    switch (action.type) {
        case SCORECARD_DETAILS_SUCCESS:
            return state = {
                ...state,
                scoreDetails: action.data
            }
        case SCORECARD_DETAILS_FAILURE:
            return state = {
                ...state,
                detailsError: action
            }
        case SCORECARD_ID:
            return state = {
                ...state,
                id: action.data
            }
        case FINANCIAL_DATA:
            return state = {
                ...state,
                financialSearch: action.data
            }
        case NON_FINANCIAL_DATA:
            return state = {
                ...state,
                nonFinancialSearch: action.data
            }
        case OVERRIDDEN_DATA:
            return state = {
                ...state,
                overriddenSearch: action.data
            }
        case VALIDATION_FLAG:
            return state = {
                ...state,
                validationFlag: action.data
            }
        case REQUEST_BODY:
            return state = {
                ...state,
                requestBody: action.data
            }
        case SEARCH_RESULTS_FAILURE:
            return state = {
                ...state,
                searchFailure: action
            }
        case SCORECARD_SUCCESS:
            return state = {
                ...state,
                createScorecardSuccess: action.data
            }
        case SCORECARD_FAILURE:
            return state = {
                ...state,
                createScorecardError: action.data
            }
            case EDIT_SCORECARD_SUCCESS: 
            return state ={
                ...state,
                editScorecardSuccess: action.data
            }
            case EDIT_SCORECARD_FAILURE: 
            return state ={
                ...state,
                editScorecardError: action.data
            }
        case CORPORATE_MODAL:
            return state = {
                ...state,
                corporateModal: !state.corporateModal
            }
        case SEARCH_CORPORATE_RESULTS_SCORECARD_SUCCESS:
            return state = {
                ...state,
                corporateResult: action.data
            }
        case SEARCH_CORPORATE_RESULTS_SCORECARD_FAILURE:
            return state = {
                ...state,
                corporateResult: action.error
            }
        default:
            return state
    }
}
export default createScorecardReducer;